/**
 * Base query handler
 * Provides common functionality for all query handlers
 */

import type { ToolExecutionContext, ToolResult } from '../../types';
import { BaseQueryHandler } from '../../types';
import { withExponentialBackoff } from '../../execution';

/**
 * Query handler base class
 * Extends the interface-based base with common implementation
 */
export abstract class QueryHandlerBase<T = any> extends BaseQueryHandler<T> {
  /**
   * Execute with retry logic
   */
  async executeWithRetry(
    params: Record<string, any>,
    context?: ToolExecutionContext
  ): Promise<ToolResult> {
    return withExponentialBackoff(() => this.execute(params, context));
  }

  /**
   * Format result for response
   */
  async formatResult(data: T): Promise<ToolResult> {
    return {
      type: 'success',
      data,
      metadata: {
        toolId: this.id,
      },
    };
  }
}
